// Vendor
import $ from 'jquery';

// Elements
let $el = $('[data-placeholders]');

class PlaceholderCycle {
	constructor(el) {

		this.delay = 2000; // delay between each new placeholder
		this.typeSpeed = 100;
		this.backspaceSpeed = 25;

		// Elements
		this.$el = $(el);

		this.setup();

		el.on('blur', (evt) => {
			let $a = $(evt.relatedTarget);
			if ($a.length && typeof $a.attr('href') !== 'undefined') {
				window.location.href = $a.attr('href');
			}
		});
	}

	setup() {

		// create array of placeholders from data attribute
		this.placeholders = this.$el.data('placeholders') ? this.$el.data('placeholders').split(',') : null;

		if (this.placeholders && this.placeholders.length !== 0) {
			//start cycle
			setTimeout(() => {
				this.cycle();
			}, this.delay);
		} else {
			console.error('Placeholder cycle requires a data attribute list of comma seperated placeholders. (e.g. data-placeholders="Vaccines,Diseases,Outbreaks,News")');
		}

	}

	cycle() {

		let placeholderText = $el.attr('placeholder');

		if (!placeholderText || placeholderText.length === 0) {
			//type placeholder

			if (!this.currentPlaceholder && this.currentPlaceholder !== 0 || this.currentPlaceholder === this.placeholders.length - 1) {
				// start from beggining of list
				this.currentPlaceholder = 0;
			} else {
				// progress to next placeholder in list
				this.currentPlaceholder++;
			}

			this.typePlaceholder();
		} else {
			//delete placeholder
			this.backspacePlaceholder();
		}

	}

	typePlaceholder() {
		// type in placeholder

		let newPlaceholderText = this.placeholders[this.currentPlaceholder];
		let currentCharacter = 0;

		this.typeInterval = setInterval(() => {

			if (this.$el.is(':focus')) {
				// input is focused so show no placeholder
				this.$el.attr('placeholder', '');
			} else if (currentCharacter !== newPlaceholderText.length + 1) {
				$el.attr('placeholder', newPlaceholderText.substring(0, currentCharacter));
				currentCharacter++;
			} else {
				clearInterval(this.typeInterval);
				//cycle
				setTimeout(() => {
					this.cycle();
				}, this.delay);
			}

		}, this.typeSpeed);
	}

	backspacePlaceholder() {
		// remove old placeholder
		this.backspaceInterval = setInterval(() => {
			let placeholderText = $el.attr('placeholder');
			$el.attr('placeholder', placeholderText.substring(0, placeholderText.length - 1));
			if (placeholderText.length === 0) {
				clearInterval(this.backspaceInterval);
				//cycle to next
				this.cycle();
			}
		}, this.backspaceSpeed);
	}
}

export default PlaceholderCycle;

const _init = () => {
	if ($el.length) {
		//TODO iterate and init on each found element?
		new PlaceholderCycle($el);
	}
};

_init();
